/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSaveChatMessagesHintsByOfferModel = IModel<
  ISaveChatMessagesHintsByOfferRequest,
  TSaveChatMessagesHintsByOfferResponse
>;

export interface ISaveChatMessagesHintsByOfferRequest {
  /** Ключ аналитики **/
  analyticsKey: EAnalyticsKey;
  /** Тип сделки **/
  dealType: EDealType;
  /** Текст сообщения **/
  messageText: string;
  /** Категория объявления **/
  offerCategory: EOfferCategory;
  /** Тип объекта **/
  offerType: EOfferType;
}

export type TSaveChatMessagesHintsByOfferResponse =
  | ISaveChatMessagesHintsByOfferResponse200
  | ISaveChatMessagesHintsByOfferResponse400;

export interface ISaveChatMessagesHintsByOfferResponse200
  extends IModelResponse<ISaveChatMessagesHintsByOfferResponse> {
  statusCode: 200;
}

export interface ISaveChatMessagesHintsByOfferResponse400
  extends IModelResponse<ISaveChatMessagesHintsByOfferResponseError> {
  statusCode: 400;
}

export interface ISaveChatMessagesHintsByOfferResponse {}

export interface ISaveChatMessagesHintsByOfferResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISaveChatMessagesHintsByOfferResponse | ISaveChatMessagesHintsByOfferResponseError;

export enum EAnalyticsKey {
  /** Есть предоплата? **/
  AdvancePayment = 'advancePayment',
  /** Свободные даты **/
  AvailableDates = 'availableDates',
  /** Кадастровый номер **/
  CadastralNumber = 'cadastralNumber',
  /** Можно с детьми? **/
  ChildrenOk = 'childrenOk',
  /** Свяжитесь со мной **/
  ContactMe = 'contactMe',
  /** Сколько за сутки? **/
  DailyPrice = 'dailyPrice',
  /** Дадите скидку? **/
  GiveDiscount = 'giveDiscount',
  /** Ещё сдаёте? **/
  IsActual = 'isActual',
  /** На месяц сдаёте? **/
  MonthlyRent = 'monthlyRent',
  /** Можно ещё фото? **/
  MorePhoto = 'morePhoto',
  /** Согласны на ипотеку? **/
  MortgageOk = 'mortgageOk',
  /** Можно с животными? **/
  PetsOk = 'petsOk',
  /** Ещё продаёте? **/
  StillSelling = 'stillSelling',
  /** Хочу посмотреть **/
  WhenSee = 'whenSee',
}

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EOfferCategory {
  /** Аренда койко-места **/
  BedRent = 'bedRent',
  /** Аренда здания **/
  BuildingRent = 'buildingRent',
  /** Продажа здания **/
  BuildingSale = 'buildingSale',
  /** Аренда готового бизнеса **/
  BusinessRent = 'businessRent',
  /** Продажа готового бизнеса **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса **/
  CarServiceSale = 'carServiceSale',
  /** Аренда коммерческой земли **/
  CommercialLandRent = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  CommercialLandSale = 'commercialLandSale',
  /** Аренда коттеджа **/
  CottageRent = 'cottageRent',
  /** Продажа коттеджа **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Аренда квартиры **/
  FlatRent = 'flatRent',
  /** Продажа квартиры **/
  FlatSale = 'flatSale',
  /** Продажа доли в квартире **/
  FlatShareSale = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  GarageRent = 'garageRent',
  /** Продажа гаража **/
  GarageSale = 'garageSale',
  /** Аренда дома/дачи **/
  HouseRent = 'houseRent',
  /** Продажа дома/дачи **/
  HouseSale = 'houseSale',
  /** Аренда части дома **/
  HouseShareRent = 'houseShareRent',
  /** Продажа части дома **/
  HouseShareSale = 'houseShareSale',
  /** Аренда производства **/
  IndustryRent = 'industryRent',
  /** Продажа производство **/
  IndustrySale = 'industrySale',
  /** Продажа участка **/
  LandSale = 'landSale',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда офиса **/
  OfficeRent = 'officeRent',
  /** Продажа офиса **/
  OfficeSale = 'officeSale',
  /** Аренда общепита **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита **/
  PublicCateringSale = 'publicCateringSale',
  /** Аренда комнаты **/
  RoomRent = 'roomRent',
  /** Продажа комнаты **/
  RoomSale = 'roomSale',
  /** Аренда торговой площади **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  TownhouseRent = 'townhouseRent',
  /** Продажа таунхауса **/
  TownhouseSale = 'townhouseSale',
  /** Аренда склада **/
  WarehouseRent = 'warehouseRent',
  /** Продажа склада **/
  WarehouseSale = 'warehouseSale',
}

export enum EOfferType {
  /** коммерческая **/
  Commercial = 'commercial',
  /** квартиры **/
  Flat = 'flat',
  /** новостройки **/
  Newobject = 'newobject',
  /** загородка **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISaveChatMessagesHintsByOfferResponse): TResponse200;
  400(response: ISaveChatMessagesHintsByOfferResponseError): TResponse400;
}
